import { MenuOpen } from '@mui/icons-material';
import { Fab, styled, Tooltip, Typography } from '@mui/material';
import React from 'react';

const IconContainer = styled('span')(() => {
  return {
    color: 'gray',
    transition: 'all 0.2s ease-in-out',
    display: 'flex',
    span: {
      color: 'black',
      marginLeft: '5px',
    },
  };
});

const DrawerToggleTooltip = styled(Tooltip)({
  boxShadow:
    '0px 3px 5px -1px rgba(0, 0, 0, 0.20), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)',
});

const DrawerToggleFab = styled(Fab)({
  backgroundColor: 'white',
  margin: '0px',
  height: '25px',
  width: '25px',
  minHeight: '0',
  boxShadow: 'none',
});

const DrawerToggleButton = ({
  isDrawerOpen,
  setIsDrawerOpen,
  tooltipCaption,
}: {
  isDrawerOpen: boolean;
  setIsDrawerOpen: (newValue: boolean) => void;
  tooltipCaption: string;
}) => (
  <IconContainer>
    <DrawerToggleTooltip
      key={isDrawerOpen ? 'open' : 'close'}
      title={<Typography variant="caption">{tooltipCaption}</Typography>}
      id={`drawer-action-label-${isDrawerOpen ? 'open' : 'close'}`}
      PopperProps={{ keepMounted: true }}
    >
      <DrawerToggleFab
        aria-labelledby={`drawer-action-label-${isDrawerOpen ? 'open' : 'close'}`}
        tabIndex={1}
        onClick={() => setIsDrawerOpen(!isDrawerOpen)}
      >
        <MenuOpen
          sx={{
            height: '20px',
            width: '20px',
            transform: isDrawerOpen ? 'rotate(0deg)' : 'rotate(180deg)',
          }}
        />
      </DrawerToggleFab>
    </DrawerToggleTooltip>
  </IconContainer>
);

export default DrawerToggleButton;
